import React from "react";

const RightSideSettingsWrapper = ({ children }) => {
  return (
    <div className="row right-side-wrapper-row">
      <div className="col-12">{children}</div>
    </div>
  );
};

export default RightSideSettingsWrapper;
